module.exports = __webpack_public_path__ + "static/img/office-ods-optimized.9c3c8be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/office-ods-optimized.jpg
// module id = 581
// module chunks = 1